export class BookingNotes {
  constructor() {}

  bbqNote = `
    <strong>BBQ Booking Information</strong>
    <p></p>
    <strong>Booking Requirements</strong>
    <p></p>
    <ul>
        <li>BBQ use must be booked <strong>at least one business day in advance</strong> to allow time for processing.</li>
        <li>BBQ bookings are for the BBQ facility only and do not reserve the entire terrace area.</li>
        <li>A booking notice will be displayed in the BBQ area before your booking.</li>
        <li><strong>Maximum booking duration: 2 hours.</strong> If there is no booking after your session, you may continue using the BBQ.</li>
    </ul>
    <p></p>
    <strong>Terrace Closing Time</strong>
    <ul>
        <li>The Level 4 Terrace <strong>closes at 10 pm</strong> daily.</li>
        <li>Lights will automatically switch off at 10 pm, and lift fob access to Level 4 will no longer be available.</li>
        <li>All users must finish and leave the area by 10 pm.</li>
    </ul>
    <p></p>
    <strong>Cleaning Requirements</strong>
    <ul>
        <li>Residents are encouraged to wipe the BBQ before use for hygiene reasons.</li>
        <li>The BBQ <strong>must be cleaned after use,</strong> including the drip tray (lift and pull out to clean once cooled).</li>
        <li>Residents <strong>must bring and use their own cleaning tools and materials.</strong></li>
        <li>Any items in the BBQ cabinet (other than the bin and replacement rubbish bags) have not been supplied by the Owners Corporation and may have been left by other residents.</li>
        <li><strong>Do not pour cleaning water, grease, or chemicals into the planter boxes.</strong> Please use the designated sink.</li>
        <li>If the bin is full, please remove the rubbish bag, dispose of it properly, and replace it with a new one. Replacement bags are stored in the cabinet where the bin is located.</li>
    </ul>
    <p></p>
    <strong>Protecting the Terrace Surface</strong>
    <ul>
        <li>If any liquid or substance is spilled on the tiles, please <strong>clean it immediately</strong> to minimise potential damage.</li>
        <li>The terrace is finished with natural stone tiles, which are porous and sensitive to acidic substances.</li>
        <li>Oil, grease, or acidic liquids (such as vinegar, lemon, wine, coffee, and tomato-based products) may cause staining if left on the surface.</li>
    </ul>
    <p></p>
    <strong>Further Information</strong>
    <ul>
        <li>Please refer to the <a href="https://108reflections.com.au/images/BBQ_cleaning_Critical_Areas.jpg" target="_blank">cleaning guide image</a> for critical areas that must be cleaned.</li>
        <li>See the <a href="https://108reflections.com.au/pdf/Level_4_Terrace_Facilities_Rules.pdf" target="_blank">Level 4 Terrace Facilities Rules</a> for full details.</li>
    </ul>
  `;

  moveNote = `
    <strong>Moving In / Out - Booking & Rules</strong>
    <p></p>
    <strong>Booking</strong>
    <p></p>
    A moving booking is required and can only be made during business hours (excluding public holidays):
    <br/>
     Monday - Friday: 8 am - 6 pm
    <br/>
     Saturday: 9 am - 1 pm
    <p></p>
    <ul>
        <li>When booking, provide the time your removalists are expected to <strong>arrive at Reflections,</strong> not the time they start at your old place.</li>
        <li>Please respect the booked time and inform the building manager as soon as possible if your removalists are <strong>running late or arriving early.</strong></li>
        <li>If removalists arrive significantly later than the booked time, the <strong>booking may need to be shortened or rescheduled</strong> depending on lift availability and business hours.</li>
    </ul>
    <strong>Moving Access</strong>
    <ul>
        <li><strong>All large items</strong> must be moved via the <strong>CAR PARK ENTRY ONLY.</strong></li>
        <li>Moving large items through the ground floor foyer is not permitted for safety reasons.</li>
    </ul>
    <p></p>
    <strong>Lift Use</strong>
    <ul>
        <li>The building manager will lock one lift and install <strong>lift protection pads</strong> for the move.</li>
        <li>The lift may be reserved for <strong>a maximum of 2 hours.</strong> Residents and removalists must complete the move within the booked time.</li>
    </ul>
    <strong>Lift Dimensions:</strong>
    <p></p>
    Entrance: 2100 mm (H) × 900 mm (W)
    <br/>
    Internal: 1400 mm (W) × 1970 mm (D) × 2400 mm (H)
    <p></p>
    <strong>Removalists</strong>
    <p></p>
    Residents are responsible for ensuring their removalists are aware of and follow all building rules:
    <ul>
        <li>If using professional removalists, email their <strong>Public Liability Insurance Certificate</strong> before the moving date.</li>
        <li>Upon arrival, removalists must contact the building manager and complete an <strong>indemnity form</strong> before starting the move.</li>
        <li>Notify the building manager when the removalists are <strong>ready to start moving,</strong> and wait for the building manager to lock and operate the padded lift before commencing.</li>
        <li>Advise your removalists that the <strong>building manager will be present and supervise the moving process.</strong></li>
        <li>Advise your removalists that they must <strong>follow the building manager’s instructions</strong> throughout the move.</li>
    </ul>
    <p></p>
    <strong>Parking</strong>
    <ul>
        <li>The building does not have a reserved loading zone.</li>
        <li>Removalists may park on the kerbside in front of the building, subject to availability at the time.</li>
    </ul>
    <p></p>
    <strong>Care of Common Areas</strong>
    <ul>
        <li>Take extra care when moving large items through common areas.</li>
        <li>Pay particular attention to <strong>sprinkler heads, smoke detectors, and the lift ceiling,</strong> especially when rotating or tilting large items.</li>
        <li><strong>Any damage caused to common property will be rectified at the resident’s or owner’s cost.</strong></li>
    </ul>
    <p></p>
  `;

  hardWasteNote = `
    <p></p>
    <p>Date of the next scheduled hard waste collection can be found in the Hard Waste Collection Notice in the mailroom. Please contact building manager at <a href="mailto:bm@108reflections.com.au" target="_blank">bm@108reflections.com.au</a> with details of your hard waste (description and dimensions).</p>
    <p>Do not leave any hard waste in any <strong>Common Areas (including Bin room)</strong> in the building.</p>
    <p>Please note there is a size limit for every collection, so <strong>booking</strong> is essential.</p>
    <p><strong>What they will collect</strong></p>
    <p>
        Types of hard waste that they collect includes:
        <ul>
            <li>household white goods and electrical appliances such as fridges, dishwashers, washing machines (doors must be removed) and televisions</li>
            <li>hot-water services</li>
            <li>broken furniture</li>
            <li>mattresses</li>
            <li>sofas</li>
            <li>BBQs</li>
            <li>scrap metal (no longer than 1.5 m)</li>
            <li>timber (no longer than 1.5 m)</li>
            <li>paint tins (dry paint and lids off)</li>
            <li>bikes.</li>
        </ul>
    </p>
    <p><strong>What they WON’T collect</strong></p>
    <p>
        In a hard waste collection they <strong>DO NOT</strong> collect:
        <ul>
            <li>recyclables including plastic containers, aluminium cans, paper and cardboard</li>
            <li>domestic waste including garbage bags</li>
            <li>renovation waste material including carpet, sinks, toilets and plasterboard</li>
            <li>building waste material waste including brick, stone, concrete, soil, timber, roofing iron, steel and metal</li>
            <li>hazardous waste such as asbestos</li>
            <li>liquid waste including chemicals, paint, and motor oil</li>
            <li>garden waste</li>
            <li>car bodies, parts, tyres and batteries</li>
            <li>gas cylinders</li>
            <li>polystyrene and styrofoam</li>
        </ul>
    </p>
    <p>Any unacceptable material will not be collected and you must take it back inside your property.</p>
    <p><a href='https://www.melbourne.vic.gov.au/residents/waste-recycling/Pages/hard-waste.aspx' target='_blank'>https://www.melbourne.vic.gov.au/residents/waste-recycling/Pages/hard-waste.aspx</a></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    <p></p>
    `;
}
